import React from 'react'
import TextField from '../../../../core/common/textFields/TextField'

const AddressesPromoteLead = ({ formik }: any) => {
    return (
        <div className='row mt-2'>
            <h5>Property Address Information</h5>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="Address line 1"
                        type="text"
                        // required
                        {...formik?.getFieldProps("propertyAddress.addressLine1")}
                    //   disabled={viewOnly}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="Address Line 2 "
                        type="text"
                        {...formik?.getFieldProps("propertyAddress.addressLine2")}
                    // disabled={viewOnly}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="ZipCode "
                        type="text"
                        // required
                        {...formik?.getFieldProps("propertyAddress.zipCode")}
                    // disabled={viewOnly}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="State/Region "
                        type="text"
                        // required
                        {...formik?.getFieldProps("propertyAddress.stateName")}
                    // disabled={viewOnly}
                    />
                </div>
            </div>
            <div className="col-md-6">
                <div className="form-wrap">
                    <TextField
                        label="City "
                        type="text"
                        // required
                        {...formik?.getFieldProps("propertyAddress.cityName")}
                    // disabled={viewOnly}
                    />
                </div>
            </div>


        </div>
    )
}

export default AddressesPromoteLead